import type { IAggregatedEventListItem } from "~/types/aggregatedEventListItem";
import {
  formatConsensus,
  getChanceChangeChip,
} from "~/utils/dashboardPanel/panelCopy";
import type { IRowChangeDisplay } from "~/utils/getRowChangeDisplay";
import { EventResolutionState } from "~/utils/resolution/getEventResolutionState";

export type IEventLeader = NonNullable<IAggregatedEventListItem["leader"]>;

type LeaderConsensus = Pick<
  IEventLeader,
  "chance" | "chanceChange24h" | "lowConfidence"
>;

const MIN_CHANGE_POINTS = 1;

export const LOW_CONFIDENCE_NOTE =
  "Low confidence: every platform's bid/ask gap is wider than 10¢, so none is quoting a firm price right now. This figure is the plain volume-weighted average and may be off.";

export interface IConsensusDisplay {
  value: string;
  withheld: boolean;
  change: IRowChangeDisplay | null;
  lowConfidence: boolean;
}

export const getConsensusDisplay = (
  leader: LeaderConsensus | null | undefined,
  state: EventResolutionState = EventResolutionState.OPEN
): IConsensusDisplay => {
  if (!leader || state !== EventResolutionState.OPEN) {
    return {
      value: formatConsensus(null),
      withheld: true,
      change: null,
      lowConfidence: false,
    };
  }

  return {
    value: formatConsensus(leader.chance),
    withheld: false,
    change: getChanceChangeChip(leader.chanceChange24h, MIN_CHANGE_POINTS),
    lowConfidence: leader.lowConfidence,
  };
};
